/**
 * Device-local "Hide this home" for visitors who are not signed in.
 *
 * The hide control used to answer a signed-out click with a "Sign in to hide
 * homes" toast and hide nothing (Muse audit 2026-10-20, FLEET_FORWARD W12).
 * Now the home is hidden on this device: its key lands in localStorage, and
 * every hide-aware surface merges these keys with the signed-in user's
 * hidden_listings rows (withDeviceHiddenKeys) before the exclusion runs.
 *
 * Device keys never reach the server and never touch alert emails; only a
 * signed-in hide does that, which is what the toast tells the visitor.
 */
import { deviceKeyList } from '@/lib/device-key-list'

export const DEVICE_HIDDEN_STORAGE_KEY = 'rr_hidden_listings_v1'

/** Newest kept. A device list past this is someone hiding a whole market. */
export const DEVICE_HIDDEN_MAX = 200

const hidden = deviceKeyList(DEVICE_HIDDEN_STORAGE_KEY, DEVICE_HIDDEN_MAX)

/** Keys hidden on this device, newest first. Empty when storage is unavailable. */
export const readDeviceHiddenKeys = hidden.read

/** Hide on this device. True when it was stored. Re-hiding moves it to the front. */
export const addDeviceHiddenKey = hidden.add

/** Unhide on this device. A key that was never stored is a success no-op. */
export const removeDeviceHiddenKey = hidden.remove

/** The signed-in user's keys plus this device's keys, for buildHiddenKeySet. */
export function withDeviceHiddenKeys(serverKeys: readonly string[]): string[] {
  const device = readDeviceHiddenKeys()
  return device.length === 0 ? [...serverKeys] : [...serverKeys, ...device]
}
